module.exports = __webpack_public_path__ + "static/img/banner-session-bienvenida-1680x1050.a85e176.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-session-bienvenida-1680x1050.jpg
// module id = UBK1
// module chunks = 47